import styled from 'styled-components';
import splash from '@/assets/images/splash.webp';
import { pagePaths } from '@/modules/defines/paths';
import { NavLink } from 'react-router';
import { body1, palette } from '@/modules/defines/styles';
import { logClickIntroButton, logPageView } from '@/utils/amplitude';
import { useEffect } from 'react';
const Button = styled(NavLink)<{ $isPending?: boolean }>`
  width: 20.5rem;
  padding: 1.125rem 5rem;
  ${body1};
  text-align: center;
  text-decoration: none;
  color: ${(props) => (props.$isPending ? palette.gray300 : 'white')};
  background: ${(props) =>
    props.$isPending ? palette.gray100 : palette.primaryBlack950};
  border-radius: 10px;
  border: none;
  pointer-events: ${(props) => (props.$isPending ? 'none' : 'auto')};
  &:active {
    background: ${(props) =>
      props.$isPending ? 'transparent' : palette.gray700};
  }
`;

const IntroContainer = () => {
  useEffect(() => {
    logPageView('/');
  }, []);
  return (
    <Container>
      <BackgroundImage src={splash} />
      <ButtonWrapper>
        <Button
          to={pagePaths.main}
          onClick={() => logClickIntroButton('start')}
        >
          시작하기
        </Button>
        <Button
          to={pagePaths.parking}
          onClick={() => logClickIntroButton('parking')}
        >
          주차장 보기
        </Button>
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;
const BackgroundImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 160px;
  left: 50%;
  width: 100%;

  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 8px;
`;

export default IntroContainer;
